import { useEffect, useRef, useState } from "react";

import { cx } from "@/utils";
import scrollIntoView from "@/utils/scroll-into-view";
import ReaderControl from "./reader-control";

export default function Section({ id, content }) {
  const [height, setHeight] = useState(600);
  const sectionRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (sectionRef.current) {
      const sectionElement = sectionRef.current;
      setHeight(sectionElement.scrollHeight);
    }
  }, []);

  const onClick = () => {
    if (isOpen) {
      scrollIntoView(sectionRef.current).then(() => setIsOpen(false));
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      <section
        id={id}
        ref={sectionRef}
        className={cx(
          "overflow-hidden overflow-y-hidden transition-all duration-300",
          !isOpen &&
            "relative after:absolute after:bottom-0 after:left-0 after:right-0 after:h-40 after:bg-gradient-to-b after:from-transparent after:to-white",
        )}
        style={{
          height: isOpen ? `${height}px` : "600px",
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <ReaderControl
        onClick={() => onClick(!isOpen)}
        sectionId={id}
        isActive={isOpen}
      />
    </>
  );
}
